// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","973":"agreement"}[chunkId] + "." + {"594":"44862c57","973":"36fc12d4"}[chunkId] + ".js";
};